import { render, staticRenderFns } from "./ProgramActivityCreateDetail.vue?vue&type=template&id=0fe7dfd4"
import script from "./ProgramActivityCreateDetail.vue?vue&type=script&lang=js"
export * from "./ProgramActivityCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./ProgramActivityCreateDetail.vue?vue&type=style&index=0&id=0fe7dfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports